import React from "react";

// The use of the component is to trigger a page refresh
export default function RefreshPage() {
  window.location.reload();
  return <span />;
}
